import React, { useState } from "react";
import SignUpOptions from "./signupOptions";
import SignUpForm from "./SignUp";
import previewImg from "./Components/HeroSection/assets/signup-preview.png"; // Replace with your own image
import { HiCalendar } from "react-icons/hi";
import { FiUsers } from "react-icons/fi";
import { FaRocket } from "react-icons/fa";
import "../css/signupPage.css";

const SignupPage = () => {
  const [showForm, setShowForm] = useState(false);

  return (
    <div className="outer-container">
  <div className="inner-wrapper">

    {/* LEFT SIDE */}
    {!showForm ? (
      <SignUpOptions onEmailClick={() => setShowForm(true)} />
    ) : (
      <SignUpForm onBackClick={() => setShowForm(false)} />
    )}

    {/* RIGHT SIDE (always same) */}
    <div className="signup-right">
      <div className="right-content">
        <div className="preview-header">
          <h2>Learn. Share. Grow.</h2>
          <p>
            Upskillmeet helps you connect with peers, experts, and new
            opportunities.
          </p>
        </div>

        <div className="preview-box">
          <img src={previewImg} alt="Preview" className="preview-image" />
        </div>

        <div className="feature-section">
          <div className="feature-item">
            <HiCalendar className="feature-icon" />
            <h4>Host your sessions</h4>
            <p>Organize and deliver upskilling sessions with ease.</p>
          </div>

          <div className="feature-item">
            <FiUsers className="feature-icon" />
            <h4>Grow your network</h4>
            <p>Connect with learners and professionals worldwide.</p>
          </div>

          <div className="feature-item">
            <FaRocket className="feature-icon" />
            <h4>Boost your skills</h4>
            <p>Learn faster with focused, peer-driven collaboration.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
	  {/* MOBILE-ONLY FEATURES */}
  <div className="feature-section mobile-features">
    <div className="feature-item">
      <HiCalendar className="feature-icon" />
      <h4>Host your sessions</h4>
      <p>Organize and deliver upskilling sessions with ease.</p>
    </div>
    <div className="feature-item">
      <FiUsers className="feature-icon" />
      <h4>Grow your network</h4>
      <p>Connect with learners and professionals worldwide.</p>
    </div>
    <div className="feature-item">
      <FaRocket className="feature-icon" />
      <h4>Boost your skills</h4>
      <p>Learn faster with focused, peer-driven collaboration.</p>
    </div>
  </div>
</div>
  );
};

export default SignupPage;
